import type { Zero } from "@rocicorp/zero";

export namespace DateTime {
  export function useTimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  export async function getTimeZone(_zero: Zero) {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}
